import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export type FlattenedUser = Record<string, string | null>;

export const removeFields = <
  RecordType extends Record<string, unknown>,
  Fields extends (keyof RecordType)[],
>(
  record: RecordType,
  fields: Fields
): Omit<RecordType, Fields[number]> => {
  const fieldsSet = new Set(fields);
  const filteredEntries = Object.entries(record)
    .filter(([key]) => !fieldsSet.has(key))
    .map(([key, value]) => [key, value]);
  return Object.fromEntries(filteredEntries);
};

export const dropRightWhile = <T>(input: T[], callback: (value: T) => boolean): T[] => {
  let i = input.length;
  while (i > 0 && callback(input[i - 1])) {
    i--;
  }
  return input.slice(0, i);
};

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
